// src/encounter/lib/orb-state.ts
//
// The ONE live Orb of the encounter (the Scrips Intelligence header, DS-042) shows what Scrips
// Intelligence is actually doing, never a constant (design desk, #569 review: "A hard-coded idle while
// ambient is listening or drafting is a false state signal"). The approved design binds `orbState`:
// thinking while Scrips Intelligence works, idle otherwise. This maps the ambient panel's own status
// (the DS AmbientScribeBlock states) onto the OrbIndicator states the DS supports.
import type { AmbientScribeBlockState, OrbState } from '@scripsteam/scrips-signal-ds';

export function orbStateForAmbient(status: AmbientScribeBlockState | undefined): OrbState {
  switch (status) {
    case 'recording':
      return 'streaming'; // listening to the consultation, live
    case 'processing':
      return 'thinking'; // drafting the note and proposals
    case 'failed':
      return 'error';
    default:
      // idle · editing · ready · empty · not mounted: nothing is running
      return 'idle';
  }
}
